import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './Pages/HomePage';
import Services from './components/Services';
import AboutPage from './Pages/AboutPage';
import SupplyChainPage from './Pages/SupplyChainPage';
import ManufacturingPage from './Pages/ManufacturingPage';
import ConstructionPage from './Pages/ConstructionPage';
import RetailPage from './Pages/RetailPage';
import FinancePage from './Pages/FinancePage';
import CrmPage from './Pages/CrmPage';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import TermsPage from './Pages/TermsAndConditions';
import ContactPage from './Pages/ContactPage';
import EnergyPage from './Pages/EnergyPage';

// ✅ Naye imports
import { ContactProvider, useContact } from './utils/ContactContext';
import ContactPopup from './components/ContactPopup';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

// ✅ Popup yahan render hoga — poore app ke liye ek jagah
function AppInner() {
  const { open, setOpen } = useContact();

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/services" element={<Services />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/supply-chain" element={<SupplyChainPage />} />
        <Route path="/manufacturing" element={<ManufacturingPage />} />
        <Route path="/construction" element={<ConstructionPage />} />
        <Route path="/retail" element={<RetailPage />} />
        <Route path="/crm" element={<CrmPage />} />
        <Route path="/finance" element={<FinancePage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsPage />} />
        <Route path="/contact" element={<ContactPage />} />
         <Route path="/energy" element={<EnergyPage />} />
      </Routes>

      {/* ✅ Ek baar yahan — sab jagah se open hoga */}
      <ContactPopup isOpen={open} onClose={() => setOpen(false)} />
    </>
  );
}

function App() {
  return (
    // ✅ ContactProvider ne poore app ko wrap kiya
    <ContactProvider>
      <BrowserRouter>
        <AppInner />
      </BrowserRouter>
    </ContactProvider>
  );
}

export default App;